/**
 * Legal Page Navigation
 *
 * Auto-builds a section navigation sidebar from h2 headings inside
 * .legal-page__content and highlights the active section as the user
 * scrolls.  Used by Privacy Statement and Terms of Use pages.
 */
(function () {
    'use strict';

    /** @type {HTMLElement[]} */
    let headings = [];

    /** @type {HTMLAnchorElement[]} */
    let navLinks = [];

    /** @type {string|null} */
    let activeId = null;

    /** @type {boolean} */
    let ticking = false;

    /**
     * Generates a URL-friendly slug from heading text.
     * @param {string} text - The heading text to slugify.
     * @returns {string} A lowercase, hyphen-separated slug.
     */
    function slugify(text) {
        return text
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '');
    }

    /**
     * Sets the active navigation link by id.
     * @param {string} id - The heading id to activate.
     */
    function setActive(id) {
        if (id === activeId) return;
        activeId = id;

        navLinks.forEach(function (link) {
            var isMatch = link.getAttribute('href') === '#' + id;
            link.classList.toggle('legal-page__nav-link--active', isMatch);
        });
    }

    /**
     * Determines which section heading is current based on scroll
     * position and updates the active nav link accordingly.
     */
    function updateActive() {
        var current = '';
        var threshold = 120;

        headings.forEach(function (h2) {
            if (h2.getBoundingClientRect().top <= threshold) {
                current = h2.id;
            }
        });

        if (current) {
            setActive(current);
        }
    }

    /**
     * Scroll handler throttled with requestAnimationFrame.
     */
    function onScroll() {
        if (!ticking) {
            requestAnimationFrame(function () {
                updateActive();
                ticking = false;
            });
            ticking = true;
        }
    }

    /**
     * Builds the sidebar navigation and initialises scroll-spy.
     */
    function init() {
        var navInner = document.querySelector('.legal-page__nav-inner');
        if (!navInner) return;

        var content = document.querySelector('.legal-page__content');
        if (!content) return;

        var h2List = content.querySelectorAll('h2');
        if (h2List.length === 0) return;

        headings = Array.prototype.slice.call(h2List);

        /* Title */
        var title = document.createElement('div');
        title.className = 'legal-page__nav-title';
        title.textContent = 'On this page';
        navInner.appendChild(title);

        /* Link list */
        var list = document.createElement('ul');
        list.className = 'legal-page__nav-list';

        headings.forEach(function (h2) {
            if (!h2.id) {
                h2.id = slugify(h2.textContent);
            }

            var li = document.createElement('li');
            var link = document.createElement('a');
            link.className = 'legal-page__nav-link';
            link.href = '#' + h2.id;
            link.textContent = h2.textContent;

            link.addEventListener('click', function (e) {
                e.preventDefault();
                var top = h2.getBoundingClientRect().top + window.scrollY - 80;
                window.scrollTo({ top: top, behavior: 'smooth' });
                history.replaceState(null, '', '#' + h2.id);
            });

            li.appendChild(link);
            list.appendChild(li);
            navLinks.push(link);
        });

        navInner.appendChild(list);

        /* Scroll-spy */
        window.addEventListener('scroll', onScroll, { passive: true });

        /* Activate first section by default */
        if (headings.length > 0 && headings[0].id) {
            setActive(headings[0].id);
        }
    }

    document.addEventListener('DOMContentLoaded', init);

    window.LegalPageNav = { init: init };
})();
